// extracted by mini-css-extract-plugin
module.exports =  {"content":"X1gLBfVJg6lVt7xwL6OQ"};